export default __webpack_public_path__ + "static/media/item8.f74055c9.png";